import { useEffect } from "react"
import { useBlocker } from "react-router"

export function useNavigationBlocker(message: string, shouldBlock: boolean) {
	const blocker = useBlocker(
		({ currentLocation, nextLocation }) =>
			shouldBlock && currentLocation.pathname !== nextLocation.pathname,
	)

	useEffect(() => {
		if (blocker.state === "blocked") {
			const confirmLeave = window.confirm(message)
			if (confirmLeave) {
				blocker.proceed?.()
			} else {
				blocker.reset?.()
			}
		}
	}, [blocker, message])

	useEffect(() => {
		if (!shouldBlock) {
			return
		}

		const handleBeforeUnload = (e: BeforeUnloadEvent) => {
			e.preventDefault()
			e.returnValue = ""
		}

		window.addEventListener("beforeunload", handleBeforeUnload)
		return () => window.removeEventListener("beforeunload", handleBeforeUnload)
	}, [shouldBlock])
}
